module.exports = __webpack_public_path__ + "img/湖州.6758d590.png";